module.exports = __webpack_public_path__ + "img/tp-9.8051dd87.png";